import React, { useCallback } from "react";
import { useSearch } from "../../../../contexts/SearchContext";
import { useBookingFlow } from "../hooks/useBookingFlow";
import FlightBuildStepper from "./FlightBuildStepper";
import { useSelfComposeUi } from "./SelfComposeUiContext";
import "./SelfComposeFlowHeader.css";

export default function SelfComposeFlowHeader() {
  const { selectFlightOffer, selectedFlightOffer } = useBookingFlow();
  const {
    setSelectedSelfComposeInboundDeal,
    selectedSelfComposeOutboundDeal,
    selectedSelfComposeInboundDeal,
  } = useSearch();

  const { buildPhase, setBuildPhase } = useSelfComposeUi();

  const hasOutbound = !!selectedSelfComposeOutboundDeal;
  const hasInbound = !!selectedSelfComposeInboundDeal;

  const handleStepPress = useCallback(
    (stepId) => {
      if (stepId === "outbound") {
        setSelectedSelfComposeInboundDeal(null);
        if (selectedFlightOffer?.isSelfComposeCombined) {
          selectFlightOffer(null);
        }
        setBuildPhase("outbound");
        return;
      }
      if (stepId === "inbound") {
        if (!hasOutbound) return;
        setBuildPhase("inbound");
        return;
      }
      if (stepId === "summary") {
        if (!hasOutbound || !hasInbound) return;
        setBuildPhase("summary");
      }
    },
    [
      hasOutbound,
      hasInbound,
      setBuildPhase,
      setSelectedSelfComposeInboundDeal,
      selectFlightOffer,
      selectedFlightOffer?.isSelfComposeCombined,
    ]
  );

  return (
    <header className="fsc-flow-header" dir="rtl">
      <FlightBuildStepper
        activePhase={buildPhase}
        hasOutbound={hasOutbound}
        hasInbound={hasInbound}
        onStepPress={handleStepPress}
      />
    </header>
  );
}
